export const environment = {
  production: true,
  extendMaterial: true
};
